/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
import * as c from "react";
function u(t, o, n) {
  const [d, i] = c.useState(o);
  return c.useEffect(() => {
    d !== void 0 && t.current && i(t.current.offsetWidth);
  }, n), d;
}
function r(t) {
  return typeof t == "string" ? Number(t.replace("px", "")) : t || void 0;
}
function W(t, o, n, d) {
  const i = r(o.popupSettings.width), s = (n.width !== void 0 && r(n.width)) !== i, h = d.width !== void 0, p = s ? n.width : h ? d.width : i, e = r(u(t, p));
  return s || h ? p : e && i && e > i ? e : i;
}
export {
  W as useDropdownWidth
};
